const userInfo = {
	account: '',
	password: ''
}
const userList = ['LV-666666', 'LV-555555', 'LV-100000', 'LV-888888', 'LV-560757', 'LV-597887', 'LV-377208', 'LV-965033', 'LV-111111']


const appList = {
	1: {
		name: "抖音",
		logo: "https://cache.jiuma.com/static/uploads/20250520/682c463bdb4ef.png",
	},
	2: {
		name: "快手",
		logo: "https://cache.jiuma.com/static/uploads/20250520/682c463bda903.png",
	},
	3: {
		name: "B站",
		logo: "https://cache.jiuma.com/static/uploads/20250520/682c463be16fa.png",
	},
	4: {
		name: "美团",
		logo: "https://cache.jiuma.com/static/uploads/20250520/682c463be0398.png",
	},
	5: {
		name: "淘宝",
		logo: "https://cache.jiuma.com/static/uploads/20250520/682c463c0b0ca.png",
	},
	6: {
		name: "京东",
		logo: "https://cache.jiuma.com/static/uploads/20250520/682c463be422f.png",
	},
	7: {
		name: "拼多多",
		logo: "https://cache.jiuma.com/static/uploads/20250520/682c463be279b.png",
	},
	8: {
		name: "唯品汇",
		logo: "https://cache.jiuma.com/static/uploads/20250520/682c463c0593d.png",
	},
	9: {
		name: "视频号",
		logo: "https://cache.jiuma.com/static/uploads/20250520/682c463c043f0.png",
	},
	10: {
		name: "小红书",
		logo: "https://cache.jiuma.com/static/uploads/20250520/682c463c0cc84.png",
	},
}

const animateList = [
	{
		name: '弹跳',
		code: "bounce"
	},
	{
		name: '闪光',
		code: "flash"
	},
	{
		name: '脉冲',
		code: "pulse"
	},
	{
		name: '橡皮筋',
		code: "rubberBand"
	},
	// {
	// 	name: '摇晃X',
	// 	code: "shakeX"
	// },
	// {
	// 	name: '摇晃Y',
	// 	code: "shakeY"
	// },
	{
		name: '摇头',
		code: "headShake"
	},
	{
		name: '摇摆',
		code: "swing"
	},
	{
		name: '塔达',
		code: "tada"
	},
	{
		name: '果冻',
		code: "jello"
	},

	{
		name: '心跳',
		code: "heartBeat"
	},
	{
		name: '后退',
		code: "backInDown"
	},
	{
		name: '向左后退',
		code: "backInLeft"
	},
	{
		name: '向右后台',
		code: "backInRight"
	},
	{
		name: '向上后台',
		code: "backInUp"
	},
	{
		name: '反弹',
		code: "bounceIn"
	},
	{
		name: '向下反弹',
		code: "bounceInDown"
	},
	{
		name: '向左反弹',
		code: "bounceInLeft"
	},
	{
		name: '向右反弹',
		code: "bounceInRight"
	},
	{
		name: '向上反弹',
		code: "bounceInUp"
	},
	{
		name: '淡入',
		code: "fadeIn"
	},
	{
		name: '淡入淡出',
		code: "fadeInDown"
	},
	{
		name: '淡入淡出',
		code: "fadeInDownBig"
	},
	{
		name: '左淡入',
		code: "fadeInLeft"
	},
	{
		name: '左淡入',
		code: "fadeInLeftBig"
	},
	{
		name: '右淡入',
		code: "fadeInRight"
	},
	{
		name: '右淡入',
		code: "fadeInRightBig"
	},
	{
		name: '下淡入',
		code: "fadeInUp"
	},
	{
		name: '下淡入',
		code: "fadeInUpBig"
	},
	// {
	// 	name: '左上淡入',
	// 	code: "fadeInTopLeft"
	// },
	// {
	// 	name: '右上淡入',
	// 	code: "fadeInTopRight"
	// },
	// {
	// 	name: '左下淡入',
	// 	code: "fadeInBottomLeft"
	// },
	// {
	// 	name: '右下淡人',
	// 	code: "fadeInBottomLeft"
	// },
	{
		name: '翻转',
		code: "flip"
	},
	{
		name: '翻转X',
		code: "flipInX"
	},
	{
		name: '翻转Y',
		code: "flipInY"
	},
	// {
	// 	name: '光速向右',
	// 	code: "lightSpeedInRight"
	// },
	// {
	// 	name: '光速向左',
	// 	code: "lightSpeedInLeft"
	// },
	{
		name: '旋转',
		code: "rotateIn"
	},
	{
		name: '左下旋转',
		code: "rotateInDownLeft"
	},
	{
		name: '右下旋转',
		code: "rotateInDownRight"
	},
	{
		name: '左上选择',
		code: "rotateInUpLeft"
	},
	{
		name: '左上选择',
		code: "rotateInUpRight"
	},

]
export default {
	userInfo,
	userList,
	appList,
	animateList
}